// Step 4, `#foundation` "Ask flow" gallery / `#s07` phone footer: commit as
// an Event, optionally tag the kept items Business, optionally also save a
// standing Condition. `keptCount` is always the length of `accept_ids[]` --
// the ids the user KEPT, never an exclusion list (binding rule).
import { useState } from 'react';
import { Button, Checkbox } from '@moneyskyline/ui';

export function AskCommitForm({
  eventName,
  keptCount,
  pending,
  onBack,
  onSave,
}: {
  eventName: string;
  keptCount: number;
  pending?: boolean;
  onBack: () => void;
  onSave: (input: { eventName: string; tagBusiness: boolean; saveCondition: boolean }) => void;
}) {
  const [name, setName] = useState(eventName);
  const [tagBusiness, setTagBusiness] = useState(true);
  const [saveCondition, setSaveCondition] = useState(false);

  return (
    <div className="flex flex-col gap-3" data-testid="ask-commit-form">
      <label className="flex flex-col gap-1 text-sm">
        <span className="text-xs text-muted-foreground">Event name</span>
        <input
          value={name}
          onChange={(event) => setName(event.target.value)}
          className="min-h-11 rounded-md border border-input px-3 text-sm"
        />
      </label>
      <label className="flex items-center gap-2 text-sm">
        <Checkbox checked={tagBusiness} onCheckedChange={(checked) => setTagBusiness(checked === true)} />
        Tag these {keptCount} items Business
      </label>
      <label className="flex items-center gap-2 text-sm">
        <Checkbox checked={saveCondition} onCheckedChange={(checked) => setSaveCondition(checked === true)} />
        Also save a standing condition
      </label>
      <div className="flex gap-2">
        <Button
          type="button"
          className="flex-1"
          disabled={pending || !name.trim()}
          onClick={() => onSave({ eventName: name.trim(), tagBusiness, saveCondition })}
        >
          Save event · {keptCount} item{keptCount === 1 ? '' : 's'}
        </Button>
        <Button type="button" variant="outline" onClick={onBack}>
          Back
        </Button>
      </div>
    </div>
  );
}

export default AskCommitForm;
